var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 25.9071,
    height: 22.7376,
    viewBox: "0 0 25.9071 22.7376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M2.88778 12.7679L12.2689 21.5804C12.5933 21.8852 12.7555 22.0376 12.9536 22.0376C13.1516 22.0376 13.3138 21.8852 13.6382 21.5804L23.0193 12.7679C25.6276 10.3177 25.9443 6.28574 23.7506 3.45836L23.3382 2.92673C20.7139 -0.455622 15.4464 0.111625 13.6024 3.97514C13.342 4.52088 12.5651 4.52088 12.3047 3.97514C10.4607 0.111625 5.19318 -0.455621 2.56895 2.92673L2.15647 3.45836C-0.0371829 6.28574 0.279549 10.3177 2.88778 12.7679Z",
    stroke: "#919191",
    strokeOpacity: 0.77,
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.927318239170c6ebc0937931fc9c5019.svg";
export { ForwardRef as ReactComponent };